import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  addOption,
  removeOption,
  updateOption
} from '../../../../../../_actions/question-library.action'

class Options extends Component {

  constructor(props) {
    super(props);

    this.state = {
      option: ''
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleAddOption = this.handleAddOption.bind(this);
  }

  handleChange(e) {
    this.setState({
      option: e.target.value
    })
  }

  handleAddOption() {
    this.props.dispatch(addOption(this.props.question, this.state.option));

    this.setState({
      option: ''
    });
  }

  render() {
    const { question, dispatch } = this.props;

    return <div className="form-group">
      <label htmlFor="question"><strong>Options</strong></label>

      {question.answerOption.map((option, i) => {
        return <div key={i} className="form-group">
          <div className="input-group">
            <input value={option.valueCoding.code} onChange={(e) => { this.props.dispatch(updateOption(e.target.value, i)) }} type="text" className="form-control" />
            <div className="input-group-append">
              <button onClick={() => { dispatch(removeOption(option)) }} className="btn btn-outline-secondary" type="button">-</button>
            </div>
          </div>
        </div>
      })}

      <div className="form-group">
        <div className="input-group">
          <input onChange={this.handleChange} value={this.state.option} type="text" className="form-control" />
          <div className="input-group-append">
            <button onClick={this.handleAddOption} className="btn btn-outline-secondary" type="button">+</button>
          </div>
        </div>
      </div>

    </div>
  }
}

export default connect()(Options);